"use strict";
var lodEntriesCtrl = function($scope, $uibModalInstance, lodParams) {
  var ctrl = this;
  var init = function() {
    $scope.sources = ['ICONCLASS', 'GND', 'AAT', 'Wikidata'];
    $scope.lodEntries = lodParams.entries;
    $scope.ctrl = ctrl;
    $scope.newSource = $scope.sources[0];
  };
  ctrl.addEntry = function() {
    $scope.lodEntries.push({
      source: $scope.newSource,
      id: $scope.newId
    });
    $scope.newSource = null;
    $scope.newId = null;
  };
  ctrl.deleteEntry = function(index) {
    $scope.lodEntries.splice(index, 1);
  };
  init();
};
lodEntriesCtrl.$inject = ['$scope', '$uibModalInstance', 'lodParams'];
module.exports = lodEntriesCtrl;
